import { render, staticRenderFns } from "./orderTypeDialog.vue?vue&type=template&id=72e1ba98&scoped=true"
import script from "./orderTypeDialog.vue?vue&type=script&lang=js"
export * from "./orderTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./orderTypeDialog.vue?vue&type=style&index=0&id=72e1ba98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e1ba98",
  null
  
)

export default component.exports